<template>
<div>
<!--  <v-icon :color="color" > {{icon}}</v-icon>-->
  <font-awesome-icon :icon="['fas', icon]" :style="{color:color}" />
<!--  <font-awesome-icon :icon="icon" />-->

</div>
</template>

<script>
export default {
  name: "MapIconPlaceInSearch",
  props:{icon_type:String}
  ,
  data(){
    return{
      icon:'',
      color:'',
    }
  },
  mounted() {
    this.set_icon();
  },
  methods:{
set_icon(){

  if(this.icon_type=='store'){
    this.icon='store';
    this.color='#3887BE'
}else if(this.icon_type=='electronics_store'){
    this.icon='store';
     this.color='#3887BE'
  }else if(this.icon_type=='village_landmark'){
    this.icon='building-wheat';
      this.color='#3887BE'
  }else if(this.icon_type=='hamlet_landmark'){
    this.icon='building-wheat';
      this.color='#3887BE'
  }else if(this.icon_type=='residential'){
    this.icon='building-wheat';
      this.color='#3887BE'
  }else if(this.icon_type=='city_landmark'){
    this.icon='city';
      this.color='#3887BE'
  }else if(this.icon_type=='town_landmark'){
    this.icon='city';
      this.color='#3887BE'
  }else if(this.icon_type=='gym'){
    this.icon='dumbbell';
    this.color='#212121'
  }else if(this.icon_type=='convenience_store'){
    this.icon='store';
     this.color='#3887BE'
  }else if(this.icon_type=='mobile_store'){
    this.icon='store';
     this.color='#3887BE'
  }else if(this.icon_type=='juice_shop'){
    this.icon='martini-glass-citrus';
    this.color='#7E30E1'
  }else if(this.icon_type=='cafe'){
    this.icon='mug-saucer';
    this.color='#B2A59B'
  }else if(this.icon_type=='storage'){
    this.icon='box';
    this.color='#3887BE'
  }else if(this.icon_type=='car_repair'){
    this.icon='toolbox';
    this.color='#3887BE'
  }else if(this.icon_type=='doctor'){
    this.icon='house-chimney-medical';
    this.color='#BF3131'
  }else if(this.icon_type=='kids_clothing_store'){
    this.icon='child-dress';
    this.color='#7E30E1'
  }else if(this.icon_type=='disposable_containers_store'){
    this.icon='store';
    this.color='#3887BE'
  }else if(this.icon_type=='mosque'){
    this.icon='mosque';
    this.color='#3887BE'
  }else if(this.icon_type=='history'){
    this.icon='clock-rotate-left';
    this.color='#212121'
  }
  else{
    this.icon='circle-dot';
    this.color='#13344f'
  }
  }
}
}

</script>

<style scoped>

</style>